import React from "react";
import styles from "styles/layout/Table.module.scss";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";

export const Table = (props) => {
  const {
    children,
    title, // title of table
    addIcon = true, // send true if AddIcon needed
    deleteIcon = false, //send true if DeleteIcon needded
    addIconOnClick = () => { }, // send callback for onClick
    deleteIconOnClick = () => { }, // send callback for onClick
    closeIcon = false,
    closeIconClick = () => { },
    fromIconList = false,
    //...more arguments can be added if needed
  } = props;

  return (
    <div className={styles.range_sec}>
      <div className={styles.range_head}>
        <p>{title}</p>
        {addIcon &&
          <button className={styles.plus_btn} onClick={addIconOnClick}>
            <svg id="Group_2002" data-name="Group 2002" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <circle id="Ellipse_27" data-name="Ellipse 27" cx="10.4" cy="10.4" r="10.4" transform="translate(1.6 1.6)" fill="#fff" />
              <path id="Vector" d="M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm5.25,13H13v4.25a1,1,0,0,1-2,0V13H6.75a1,1,0,0,1,0-2H11V6.75a1,1,0,0,1,2,0V11h4.25a1,1,0,0,1,0,2Z" fill="#4cb0bd" />
            </svg>
          </button>
          // <AddIcon onClick={addIconOnClick} 
          // />
        }
        {closeIcon && <CloseIcon onClick={closeIconClick} />}
        {/* {fromIconList ? (
          <ul>
            <li></li>
            <li></li>
          </ul>
        ) : (
          <ul>
            <li>{addIcon && <AddIcon onClick={addIconOnClick} />}</li>
          </ul>
        )} */}
      </div>
      <div className={`${styles.range_table} range_table`}>{children}</div>
    </div>
  );
};
